export default {"src":"/_next/static/media/panda-own.8181cb98.svg","height":100,"width":100};